export const MAX_SENDER_NAME_LENGTH = 14;
export const MAX_GREETING_LENGTH = 160;
export const MAX_GREETING_ROWS = 7;
export const DEFAULT_PHOTO =
  'https://res.cloudinary.com/klydoclock/image/upload/profile/defaultPhoto_mc2iv6.png';
